import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

const bg = "#2b2420";
const fg = "#d4c4a8";
const fgMuted = "#8c7a64";
const accent = "#c47832";
const bark = "#7a9468";

export const timber: ThemeDefinition = {
  label: "Timber",
  className: "theme-timber",
  bg,
  text: fg,
  textMuted: fgMuted,
  accent,
  glassRgb: "43,36,32",
  border: "rgba(255,255,255,0.10)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(212,196,168,0.20)",
  selection: accent,
  selectionText: bg,
  gridColor: fg,
  noiseOpacity: "0.04",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.50)",
  gpuClear: hexToSrgb(bg),
  gpuGridLine: hexToLinear(fg),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear(accent),
  gpuAxisZ: hexToLinear(bark),
  axisXColor: accent,
  axisZColor: bark,
  font: '"Libre Baskerville", serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap',
};
